<template>
  <div v-if="shouldShown" class="app-store-banner">
    <!-- TODO: 薬剤師アプリの画像ができたらここも修正 -->
    <img class="app-icon-img" src="@/assets/img/caitech-app-icon.png" />
    <div class="d-flex flex-column">
      <p class="text-size-16 text-weight-700">{{ product.name }}</p>
      <p class="text-size-10 text-mild">
        {{ product.name }} APP をインストール
      </p>
    </div>
    <div class="flex-grow-1" />
    <div>
      <a :href="appStoreLink">
        <div class="install-button">
          <div>
            <span class="install-button-label">
              インストール
            </span>
          </div>
        </div>
      </a>
    </div>
    <FeatherIcon icon="x" size="15" @click="onClose" />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { isAndroidBrowser, isIosBrowser } from "@/utils/browserUtil";
import { authStore } from "@/store/auth";

@Component({
  components: {
    AppButton,
    FeatherIcon
  }
})
export default class AppStoreBanner extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  shouldShown!: boolean;

  get product() {
    return authStore.product;
  }

  get appStoreLink() {
    if (isIosBrowser()) {
      return authStore.getPlatformStoreUrl("iOS");
    } else if (isAndroidBrowser()) {
      return authStore.getPlatformStoreUrl("Android");
    } else {
      return authStore.getPlatformStoreUrl("iOS");
    }
  }

  onClose() {
    this.$emit("close");
  }
}
</script>

<style lang="scss" scoped>
.app-store-banner {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  display: flex;
  gap: 16px;
  align-items: center;
  width: 100%;
  height: $app-store-banner-height;
  padding: 0 16px;
  background-color: #fff;
  border-bottom: 1px solid #ccc;
}

.app-icon-img {
  height: 45px;
}

.install-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 40px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  background-color: #3478f6;
  border: 1px solid #3478f6;
  border-color: #3478f6;
  border-radius: 22px;
}

.install-button-label {
  color: $white;
}
</style>
